const displayText = {
  displayLarge: {
    fontSize: '4.5rem',
    fontWeight: 500,
    lineHeight: '1.2',
    letterSpacing: '-0.02rem',
  },
  displayMedium: {
    fontSize: '3.75rem',
    fontWeight: 500,
    lineHeight: '1.3',
    letterSpacing: '-0.01rem',
  },
  displaySmall: {
    fontSize: '3rem',
    fontWeight: 600,
    lineHeight: '1.4',
  },
}

const headlineText = {
  headlineLarge: {
    fontSize: '2.25rem',
    fontWeight: 600,
    lineHeight: '1.3',
    letterSpacing: '0.01rem',
  },
  headlineMedium: {
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: '1.35',
    letterSpacing: '0.02rem',
  },
  headlineSmall: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: '1.4',
    letterSpacing: '0.02rem',
  },
}

const titleText = {
  titleLarge: {
    fontSize: '1.25rem',
    fontWeight: 700,
  },
  titleMedium: {
    fontSize: '1.125rem',
    fontWeight: 700,
  },
  titleSmall: {
    fontSize: '1rem',
    fontWeight: 700,
  },
  paraTitleLarge: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: '1.4',
    letterSpacing: '0.02rem',
  },
  paraTitleMedium: {
    fontSize: '1.125rem',
    fontWeight: 700,
    lineHeight: '1.4',
    letterSpacing: '0.02rem',
  },
  paraTitleSmall: {
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '1.4',
    letterSpacing: '0.02rem',
  },
}

const labelText = {
  labelLarge: {
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: '1.3',
  },
  labelMedium: {
    fontSize: '0.75rem',
    fontWeight: 700,
    lineHeight: '1.3',
  },
}

const bodyText = {
  bodyLarge: {
    fontSize: '1.25rem',
    fontWeight: 400,
  },
  bodyMedium: {
    fontSize: '1rem',
    fontWeight: 400,
  },
  bodySmall: {
    fontSize: '0.875rem',
    fontWeight: 400,
  },
  bodyXs: {
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  paraBodyLarge: {
    fontSize: '1.25rem',
    fontWeight: 400,
    lineHeight: '1.5',
    letterSpacing: '0.02rem',
  },
  paraBodyMedium: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.5',
    letterSpacing: '0.02rem',
  },
  paraBodySmall: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.5',
    letterSpacing: '0.02rem',
  },
  paraBodyXs: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.5',
    letterSpacing: '0.02rem',
  },
  articleBodyLarge: {
    fontSize: '1.125rem',
    fontWeight: 400,
    lineHeight: '2',
    letterSpacing: '0.01rem',
  },
  articleBodySmall: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.8',
    letterSpacing: '0.01rem',
  },
}

const textTheme = {
  ...displayText,
  ...headlineText,
  ...titleText,
  ...labelText,
  ...bodyText,
}

export default textTheme
